export function simulateMouseEvent(event, simulatedType) {

  // Prevent "Ignored attempt to cancel a touchmove event with cancelable=false" errors
  if (event.cancelable) {
    event.preventDefault()
  }

  let touch = event.nativeEvent.changedTouches[0], simulatedEvent = document.createEvent('MouseEvents')

  // Initialize the simulated mouse event using the touch event's coordinates
  simulatedEvent.initMouseEvent(
    simulatedType,    // type
    true,             // bubbles
    true,             // cancelable
    window,           // view
    1,                // detail
    touch.screenX,    // screenX
    touch.screenY,    // screenY
    touch.clientX,    // clientX
    touch.clientY,    // clientY
    false,            // ctrlKey
    false,            // altKey
    false,            // shiftKey
    false,            // metaKey
    0,                // button
    null              // relatedTarget
  )

  // Dispatch the simulated event to the target element
  event.target.dispatchEvent(simulatedEvent)
}


// Get x,y position of touch event
export function getTouchCoords (event) {
  return {
    x : event.nativeEvent.changedTouches[0].pageX,
    y : event.nativeEvent.changedTouches[0].pageY,
  }
}